import { SingleValue } from "react-select";
import Company from "./Company";
import { IFilters } from "./Fetch";
import User from "./IUser";
import { ISelectOption } from "./Select";

export type UserCompanyRole = "AE" | "SDR" | "CSM";

export const USER_COMPANY_ROLES: ISelectOption<UserCompanyRole>[] = [
  {
    value: "AE",
    label: "Commercial",
  },
  {
    value: "SDR",
    label: "Télépro",
  },
  {
    value: "CSM",
    label: "CSM",
  },
];

interface CompanyUser {
  id: string;
  userId: string;
  companyId: string;
  commission: number | null;
  company: Company;
  user: User;
  role: UserCompanyRole;
  createdAt: string;
  updatedAt: string;
}

export interface CompanyUserFilters extends IFilters {
  roles?: UserCompanyRole[];
  archived?: boolean;
}

export interface CompanyUserForm {
  user: SingleValue<User>;
  role: ISelectOption<UserCompanyRole>;
  commission: number;
}

export interface CompanyUserFormSend
  extends Omit<CompanyUserForm, "user" | "role"> {
  userId: string;
  role: UserCompanyRole;
}

export interface CompanyUserFormUpdate {
  commission: number | null;
}

export default CompanyUser;
